import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "voiceForm"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "语音叫车", -1);
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "h1"
}, "一键说出目的地，即刻叫车"), /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, [/*#__PURE__*/_createElementVNode("div", null, " 点击按钮，说出您想去的目的地 ")])], -1);
const _hoisted_5 = {
  class: "voice-one-key-layout"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 2
};
const _hoisted_9 = {
  key: 3
};
const _hoisted_10 = {
  key: 4
};
const _hoisted_11 = {
  key: 5
};
const _hoisted_12 = {
  class: "voice-address"
};
const _hoisted_13 = {
  class: "text"
};
const _hoisted_14 = {
  class: "button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "voice-one-key",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.startVoice && $options.startVoice(...args))
  }, [$setup.isRecorderEnd ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: _normalizeClass($setup.isPlaying ? 'recording' : ''),
    src: require('@/assets/icon/sound-wave.png')
  }, null, 10, _hoisted_6)) : _createCommentVNode("", true), !$setup.isRecorderEnd ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    class: _normalizeClass($setup.isRecorder ? 'recording' : ''),
    src: $setup.isRecorder ? require('@/assets/icon/voiceing.png') : require('@/assets/icon/voice.png')
  }, null, 10, _hoisted_7)) : _createCommentVNode("", true), !$setup.isPlaying && $setup.isRecorderEnd ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 播放录音 ")) : _createCommentVNode("", true), $setup.isPlaying && $setup.isRecorderEnd ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 停止播放 ")) : _createCommentVNode("", true), !$setup.isRecorder && !$setup.isRecorderEnd ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 开始说话 ")) : _createCommentVNode("", true), $setup.isRecorder && !$setup.isRecorderEnd ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 停止说话 ")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_icon, {
    name: "location"
  }), _createElementVNode("div", _hoisted_13, _toDisplayString(this.startAddress), 1)])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_van_button, {
    color: "#ff9e29",
    block: "",
    plain: "",
    disabled: $setup.loading || !$setup.isRecorderEnd && !$setup.isPlaying,
    onClick: $options.againButtonClick
  }, {
    default: _withCtx(() => [_createTextVNode(" 重新说话 ")]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_van_button, {
    color: "#ffaa33",
    block: "",
    loading: $setup.loading,
    disabled: !$setup.isRecorderEnd,
    onClick: $options.enterButtonClick
  }, {
    default: _withCtx(() => [_createTextVNode(" 立即叫车 ")]),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])]), _createElementVNode("audio", {
    id: "audio",
    style: {
      "display": "none"
    },
    controls: "",
    autoplay: "",
    onPlay: _cache[1] || (_cache[1] = $event => $setup.isPlaying = true),
    onEnded: _cache[2] || (_cache[2] = $event => $setup.isPlaying = false)
  }, null, 32)]);
}